import React, { ReactChildren, ReactChild, ReactNode, FC } from 'react';
import {Provider} from 'react-redux';
import {store} from '../../State/store';

interface AuxProps {
  children: ReactChild | ReactChildren | ReactNode;
}

const AuthProvider: FC<AuxProps> = ({children}) => {

    return (
        <Provider store = {store}>
            {children}
        </Provider>
    )
}

export default AuthProvider
